import { useState } from "react";
import { MoveHorizontal } from "lucide-react";

/**
 * Confronto trascinabile Prima/Dopo.
 * Usa clip-path per mantenere le immagini a piena scala (nessuna distorsione).
 */
export function BeforeAfterSlider({ before, after, height = 340, className = "" }) {
  const [pos, setPos] = useState(50);
  return (
    <div className={`relative w-full overflow-hidden rounded-xl select-none bg-muted ${className}`} style={{ height }} data-testid="before-after-slider">
      <img src={after} alt="Dopo" draggable={false} className="absolute inset-0 w-full h-full object-cover" />
      <img src={before} alt="Prima" draggable={false} className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />

      {/* etichette */}
      <span className="absolute top-2 left-2 text-[10px] font-semibold uppercase tracking-wider text-white bg-black/50 rounded px-1.5 py-0.5">Prima</span>
      <span className="absolute top-2 right-2 text-[10px] font-semibold uppercase tracking-wider text-white bg-black/50 rounded px-1.5 py-0.5">Dopo</span>

      {/* linea + maniglia */}
      <div className="absolute top-0 bottom-0 pointer-events-none" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="w-0.5 h-full bg-white/90 shadow" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-9 w-9 rounded-full bg-white shadow-lg flex items-center justify-center">
          <MoveHorizontal className="h-4 w-4 text-[hsl(var(--hi-gold))]" />
        </div>
      </div>

      {/* controllo (drag + tastiera) */}
      <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Confronto prima e dopo"
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize" data-testid="before-after-range" />
    </div>
  );
}
